/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SuggestCustomDetectionRuleRequestBody = {
  /**
   * Existing built-in and custom rule ids the suggested id must avoid colliding with.
   */
  existingRuleIds?: Array<string> | undefined;
  /**
   * Natural-language description of what the rule should detect.
   */
  prompt: string;
};

/** @internal */
export type SuggestCustomDetectionRuleRequestBody$Outbound = {
  existing_rule_ids?: Array<string> | undefined;
  prompt: string;
};

/** @internal */
export const SuggestCustomDetectionRuleRequestBody$outboundSchema:
  z.ZodMiniType<
    SuggestCustomDetectionRuleRequestBody$Outbound,
    SuggestCustomDetectionRuleRequestBody
  > = z.pipe(
    z.object({
      existingRuleIds: z.optional(z.array(z.string())),
      prompt: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        existingRuleIds: "existing_rule_ids",
      });
    }),
  );

export function suggestCustomDetectionRuleRequestBodyToJSON(
  suggestCustomDetectionRuleRequestBody: SuggestCustomDetectionRuleRequestBody,
): string {
  return JSON.stringify(
    SuggestCustomDetectionRuleRequestBody$outboundSchema.parse(
      suggestCustomDetectionRuleRequestBody,
    ),
  );
}
